import { useSelector } from "react-redux"
import { retrieveData } from "../../../helpers/helpers"

import { classNames } from "../../tools/ClassNames"
const OtherWarehouseGrid = ({ productos, addProduct, url, headers, setShowForm }) => {

    const IdEmp = useSelector(state => state.auth.IdEmp)

    const handleClick = async (producto) => {
        try {
            await retrieveData({
                method: 'POST',
                url,
                headers,
                payload: {
                    IdProducto: producto.IdProducto,
                    IdBodega: producto.IdBodega,
                    IdEmp
                }
            })

            addProduct(producto)
            setShowForm(false)

        } catch (err) {
            console.log(err)
        }
    }

    return(
        <>
        <div className="sm:px-6 lg:px-8 p-5 pb-0 h-full">
            <div className="flex flex-col p-3 pt-0">
                <div className="-mx-4 sm:-mx-6 lg:-mx-8 overflow-auto">
                <div className="inline-block min-w-full align-middle">
                    <div className='h-full'>
                    <table className="min-w-full border-separate" style={{ borderSpacing: 0 }}>
                        <thead className="bg-secundarioMira">
                            <tr>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                >
                                    Bodega
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-grisMira sm:pl-6 lg:pl-8"
                                >
                                    Producto
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Precio Unitario
                                </th>
                                <th
                                scope="col"
                                className="sticky top-0 z-10 bg-secundarioMira border-b border-gray-300 px-3 py-3.5 text-left text-sm font-semibold text-grisMira"
                                >
                                    Existencia
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-secundarioMira overflow-y-scroll">
                        {productos.map((producto, Idx) =>   
                                <tr 
                                key={Idx} 
                                className='cursor-pointer hover:bg-primarioMira hover:shadow-2xl transition-colors duration-300 ease-in-out'
                                onClick={() => handleClick(producto)}
                                >
                                    <td
                                        className={classNames(
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap py-2 pl-4 pr-3 text-sm font-medium text-white sm:pl-6 lg:pl-8'
                                        )}
                                    >
                                        {producto.Bodega}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {producto.Descripcion_Corta}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {Intl.NumberFormat('es-GT', { style: 'currency', currency: 'GTQ' }).format(producto.Precio)}
                                    </td>
                                    <td
                                        className={classNames(
                                        Idx !== productos.length - 1 ? 'border-b-2 border-b-primarioMira' : '',
                                        'whitespace-nowrap px-3 py-2 text-sm text-white'
                                        )}
                                    >
                                        {producto.Existencia}
                                    </td>
                                </tr>
                        )}
                        </tbody>
                    </table>
                    </div>
                </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default OtherWarehouseGrid